export const FETCH_STATUS = {
  UNINITIALIZED: "uninitialized",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};
